import { createContext } from 'react';

/**
 * Context to track when a component is rendered inside a Tabs component
 * Used to prevent nested GutterContainers when Table is inside Tabs
 */
export const TabsContext = /*#__PURE__*/createContext(false);